import { mapActions } from 'vuex'
import { $t } from '@/i18n.js'
import { transformDateTypeEnglishWithSpace } from '@/helpers/functions/convertDate'
const networksCaptions = {
  instagram: { nameCaption: 'instagram_caption', color: '#C32AA3', icon: 'mdi-instagram' },
  facebook: { nameCaption: 'facebook_caption', color: '#3b5998', icon: 'mdi-facebook' },
  google: { nameCaption: 'google_localpost_summary', color: '#4582E9', icon: 'mdi-google-my-business' },
  linkedin: { nameCaption: 'linkedin_commentary', color: '#0077B5', icon: 'mdi-linkedin' }
}

export const modalPostSocialNetworksMixin = {
  ...mapActions('calendarSocialPosts', ['createEventNow']),
  methods: {
    modalPost () {
      if (this.datePost != null) {
        // Après définition de la date
        this.$confirm(
          this.currentEtat === 'planned' ? $t('general.calendar.areYouSureYouWantToPlanYourPost') : $t('general.calendar.areYouSureYouWantToPublishYourPost'),
          this.currentEtat === 'planned' ? $t('general.calendar.planningPost') : $t('general.calendar.publishingPost'),
          {
            confirmButtonText: $t('general.calendar.acceptedPost'),
            cancelButtonText: $t('general.calendar.refusedPost'),
            type: 'warning'
          }).then(() => {
          // Etat
          this.statusPost = this.currentEtat
          if (this.currentEtat === 'published') {
            this.isDatePickerVisible = true
            // Add date in input
            this.cronExpression = '* * * * *'
          } else {
            // Ajout du cronExpression
            const newDate = new Date(this.datePost)
            this.cronExpression = `${newDate.getMinutes()} ${newDate.getUTCHours()} ${newDate.getUTCDate()} ${newDate.getUTCMonth() + 1} *`
          }
          // Envoie de la donnée au store pour traitement
          const payload = {
            annonceurId: this.post.advertiser.id,
            annonceurLogin: this.post.advertiser.login,
            annonces: [parseInt(this.$route.params.id)],
            type: 'MANUEL',
            scheduled: {
              cronExpression: this.cronExpression,
              status: '1'
            },
            cancelBy: null,
            portails: [{ code: this.codeNetwork, value: this.valueNetwork }]
          }
          const portal = this.codeNetwork.split('_')[0].toLowerCase()
          const nameCaption = networksCaptions[portal].nameCaption
          const contentCaption = this.post[nameCaption] ? this.post[nameCaption] : this.getCaption.text
          const colorCaption = networksCaptions[portal].color
          const iconCaption = networksCaptions[portal].icon
          const newEventPart = {
            titre: this.post.titre,
            name: this.post.titre,
            reference: this.post.reference,
            picture: (this.post.photoPrincipale) ? this.post.photoPrincipale.url : null,
            start: transformDateTypeEnglishWithSpace(this.datePost),
            color: colorCaption,
            icon: iconCaption,
            [`${nameCaption}`]: contentCaption
          }
          if (contentCaption === undefined) {
            this.$message({
              type: 'info',
              message: 'Le contenu de votre post doit être complété.'
            })
          } else {
            try {
              this.createEventNow({ payloadPlanif: payload, newEvent: newEventPart })
                .then((res) => {
                  this.$message({
                    type: 'success',
                    message: this.currentEtat === 'planned' ? $t('general.calendar.thePostWasPlanned') : $t('general.calendar.thePostWasPublished')
                  })
                })
            } catch (e) {
              this.$message({
                type: 'error',
                message: this.currentEtat === 'planned' ? $t('general.calendar.ThePlanningWasUnsuccessful') : $t('general.calendar.ThePublicationWasUnsuccessful')
              })
            }
          }
        }).catch(() => {
          this.datePost = null
          if (this.currentEtat === 'planned') {
            this.isDatePickerVisible = false
          }
          this.$message({
            type: 'info',
            message: this.currentEtat === 'planned' ? $t('general.calendar.TheCurrentScheduleHasBeenCanceled') : $t('general.calendar.TheCurrentPublicationHasBeenCanceled')
          })
        })
      }
      this.statusPost = 'no planned'
      this.isDatePickerVisible = false
    }
  }
}
